import useAppState from '../../state/appState';
import { isElementVisible, isHiddenElement } from '../../conditional-fields/evaluate-field-condition';
import { getElementFromElementId } from '../../helpers/getElementFromElementId';
import { ClaimFormSubmitFieldValue } from '../../types/claim-form-submit-field-value';

import { FormValues, FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';
import { Field } from '../../types/fields';
import { StagedFile } from '../../types/services';

// Basic
import Checkboxes from '../fields/Checkboxes';
import Currencyfield from '../fields/Currencyfield';
import Datepicker from '../fields/Datepicker';
import NumberField from '../fields/Numberfield';
import Radiobuttons from '../fields/Radiobuttons';
import Textarea from '../fields/Textarea';
import Textfield from '../fields/Textfield';
import Yearfield from '../fields/Yearfield';
import Cprfield from '../fields/Cprfield';
import Cvrfield from '../fields/Cvrfield';
import Dropdown from '../fields/Dropdown';
import EmailField from '../fields/EmailField';
import PhoneField from '../fields/PhoneField';
import LicensePlateField from '../fields/LicensePlateField';

// Custom
import LandingPage from '../custom/LandingPage';
import NotImplemented from '../custom/NotImplemented';
import AmountOrUnknown from '../custom/AmountOrUnknown';
import UploadDocumentation from '../fields/UploadDocumentation';
import ContentBlock from '../custom/ContentBlock';
import SummaryPage from '../custom/SummaryPage';
import Info from '../fields/Info';
import Attention from '../fields/Attention';
import ContactEmail from '../custom/ContactEmail';
import ContactPhone from '../custom/ContactPhone';
import ContactUpdateProfile from '../custom/ContactUpdateProfile';
import HouseAddress from '../custom/HouseAddress/HouseAddress';
import Addressfield from '../fields/AddressField';
import CustomerVehicle from '../custom/CustomerVehicle/CustomerVehicle';
import Consent from '../custom/Consent';
import VehicleZones from '../custom/VehicleZones/VehicleZones';
import TimeIntervals from '../custom/TimeIntervals';
import CarBrands from '../custom/CarBrands';
import Countries from '../custom/Countries';
import SupManWidget from '../custom/SupManWidget/SupManWidget';
import SelectWorkshop from '../custom/SelectWorkshop/SelectWorkshop';
import YouAreCovered from '../custom/YouAreCovered/YouAreCovered';
import Scalepoint from '../custom/Scalepoint/Scalepoint';
import PetSelector from '../custom/PetSelector/PetSelector';
import Teeth from '../custom/Teeth/Teeth';
import PetClaimSelector from '../custom/PetClaimSelector/PetClaimSelector';
import OtherCompany from '../custom/OtherCompany/OtherCompany';
import AutomaticConsent from '../custom/AutomaticConsent';
import Examination from '../custom/Examination/Examination';
import PreviousExamination from '../custom/Examination/PreviousExamination';
import GroupOfTextFields from '../custom/GroupOfTextFields';
import PoliceDistrict from '../custom/PoliceDistrict';
import CarbucksPage from '../custom/CarbucksPage';

export const getResumeSectionFromElement = (formConfig: FormConfig, formValues: FormValues, elementId: string) => {
    const element = getElementFromElementId(formConfig, elementId);
    const elementType = element.type;

    switch (elementType) {
        case 'uploadDocumentation':
            return UploadDocumentation.ResumePage(formConfig, formValues, elementId);
        case 'radiobuttons':
            return Radiobuttons.ResumePage(formConfig, formValues, elementId);
        case 'checkboxes':
            return Checkboxes.ResumePage(formConfig, formValues, elementId);
        case 'numberfield':
            return NumberField.ResumePage(formConfig, formValues, elementId);
        case 'currencyfield':
            return Currencyfield.ResumePage(formConfig, formValues, elementId);
        case 'datepicker':
            return Datepicker.ResumePage(formConfig, formValues, elementId);
        case 'textarea':
            return Textarea.ResumePage(formConfig, formValues, elementId);
        case 'textfield':
            return Textfield.ResumePage(formConfig, formValues, elementId);
        case 'amountOrUnknown':
            return AmountOrUnknown.ResumePage(formConfig, formValues, elementId);
        case 'yearfield':
            return Yearfield.ResumePage(formConfig, formValues, elementId);
        case 'cprfield':
            return Cprfield.ResumePage(formConfig, formValues, elementId);
        case 'cvrfield':
            return Cvrfield.ResumePage(formConfig, formValues, elementId);
        case 'dropdown':
            return Dropdown.ResumePage(formConfig, formValues, elementId);
        case 'contactEmail':
            return ContactEmail.ResumePage(formConfig, formValues, elementId);
        case 'contactPhone':
            return ContactPhone.ResumePage(formConfig, formValues, elementId);
        case 'contactUpdateProfile':
            return ContactUpdateProfile.ResumePage(formConfig, formValues, elementId);
        case 'houseAddress':
            return HouseAddress.ResumePage(formConfig, formValues, elementId);
        case 'addressfield':
            return Addressfield.ResumePage(formConfig, formValues, elementId);
        case 'phoneField':
            return PhoneField.ResumePage(formConfig, formValues, elementId);
        case 'customerVehicle':
            return CustomerVehicle.ResumePage(formConfig, formValues, elementId);
        case 'consent':
            return Consent.ResumePage(formConfig, formValues, elementId);
        case 'vehicleZones':
            return VehicleZones.ResumePage(formConfig, formValues, elementId);
        case 'timeIntervals':
            return TimeIntervals.ResumePage(formConfig, formValues, elementId);
        case 'carBrands':
            return CarBrands.ResumePage(formConfig, formValues, elementId);
        case 'countries':
            return Countries.ResumePage(formConfig, formValues, elementId);
        case 'supManWidget':
            return SupManWidget.ResumePage(formConfig, formValues, elementId);
        case 'selectWorkshop':
            return SelectWorkshop.ResumePage(formConfig, formValues, elementId);
        case 'youAreCovered':
            return YouAreCovered.ResumePage();
        case 'scalepointwidget':
            return Scalepoint.ResumePage(formConfig, formValues, elementId);
        case 'animal':
            return PetSelector.ResumePage(formConfig, formValues, elementId);
        case 'teeth':
            return Teeth.ResumePage(formConfig, formValues, elementId);
        case 'animalsicknessexistingclaimswidget':
            return PetClaimSelector.ResumePage(formConfig, formValues, elementId);
        case 'emailField':
            return EmailField.ResumePage(formConfig, formValues, elementId);
        case 'otherCompany':
            return OtherCompany.ResumePage(formConfig, formValues, elementId);
        case 'automaticConsent':
            return AutomaticConsent.ResumePage(formConfig, formValues, elementId);
        case 'examination':
            return Examination.ResumePage(formConfig, formValues, elementId);
        case 'previousexamination':
            return PreviousExamination.ResumePage(formConfig, formValues, elementId);
        case 'groupOfTextFields':
            return GroupOfTextFields.ResumePage(formConfig, formValues, elementId);
        case 'licenseplatefield':
            return LicensePlateField.ResumePage(formConfig, formValues, elementId);
        case 'policedistricts':
            return PoliceDistrict.ResumePage(formConfig, formValues, elementId);
        default:
            throw new Error(`Resume page - Unknown elementType: ${elementType}`);
    }
};

export const getValueSubmit = (
    formConfig: FormConfig,
    formValues: FormValues,
    elementId: string,
    caption: string,
    stagedFiles: StagedFile[]
): ClaimFormSubmitFieldValue | ClaimFormSubmitFieldValue[] | undefined => {
    const element = getElementFromElementId(formConfig, elementId);
    const elementType = element.type;

    switch (elementType) {
        case 'uploadDocumentation':
            return UploadDocumentation.getValueSubmit(formValues, elementId, caption, stagedFiles);
        case 'radiobuttons':
            return Radiobuttons.getValueSubmit(formValues, elementId, caption);
        case 'checkboxes':
            return Checkboxes.getValueSubmit(formValues, elementId, caption);
        case 'textfield':
            return Textfield.getValueSubmit(formValues, elementId, caption);
        case 'numberfield':
            return NumberField.getValueSubmit(formValues, elementId, caption);
        case 'currencyfield':
            return Currencyfield.getValueSubmit(formValues, elementId, caption);
        case 'datepicker':
            return Datepicker.getValueSubmit(formValues, elementId, caption);
        case 'textarea':
            return Textarea.getValueSubmit(formValues, elementId, caption);
        case 'amountOrUnknown':
            return AmountOrUnknown.getValueSubmit(formValues, elementId, caption);
        case 'yearfield':
            return Yearfield.getValueSubmit(formValues, elementId, caption);
        case 'cprfield':
            return Cprfield.getValueSubmit(formValues, elementId, caption);
        case 'cvrfield':
            return Cvrfield.getValueSubmit(formValues, elementId, caption);
        case 'dropdown':
            return Dropdown.getValueSubmit(formValues, elementId, caption);
        case 'contactEmail':
            return ContactEmail.getValueSubmit(formValues, elementId, caption);
        case 'contactPhone':
            return ContactPhone.getValueSubmit(formValues, elementId, caption);
        case 'contactUpdateProfile':
            return ContactUpdateProfile.getValueSubmit(formValues, elementId, caption);
        case 'houseAddress':
            return HouseAddress.getValueSubmit(formValues, elementId, caption, formConfig);
        case 'addressfield':
            return Addressfield.getValueSubmit(formValues, elementId, caption);
        case 'phoneField':
            return PhoneField.getValueSubmit(formValues, elementId, caption);
        case 'customerVehicle':
            return CustomerVehicle.getValueSubmit(formValues, elementId, caption);
        case 'consent':
            return Consent.getValueSubmit(formValues, elementId, caption);
        case 'vehicleZones':
            return VehicleZones.getValueSubmit(formValues, elementId, caption);
        case 'timeIntervals':
            return TimeIntervals.getValueSubmit(formValues, elementId, caption);
        case 'carBrands':
            return CarBrands.getValueSubmit(formValues, elementId, caption);
        case 'countries':
            return Countries.getValueSubmit(formValues, elementId, caption);
        case 'supManWidget':
            return SupManWidget.getValueSubmit(formValues, elementId, caption);
        case 'automaticConsent':
            return AutomaticConsent.getValueSubmit(formValues, elementId, caption);
        case 'selectWorkshop':
            const valueSubmit = SelectWorkshop.getValueSubmit(formValues, elementId, caption);

            if (valueSubmit.value === 'Du har valgt eget værksted') {
                return valueSubmit;
            }
            //only submit selectWorkshop as 'supManWidget' when customer choose own workshop
            //otherwise skip this component as the workshop data will be submiited via "real" 'supManWidget'
            return undefined;
        case 'youAreCovered':
            return YouAreCovered.getValueSubmit(formValues, elementId, caption);
        case 'scalepointwidget':
            return Scalepoint.getValueSubmit(formValues, elementId, caption);
        case 'animal':
            return PetSelector.getValueSubmit(formValues, formConfig, elementId, caption);
        case 'teeth':
            return Teeth.getValueSubmit(formConfig, formValues, elementId, caption);
        case 'animalsicknessexistingclaimswidget':
            return PetClaimSelector.getValueSubmit(formValues, elementId, caption);
        case 'emailField':
            return EmailField.getValueSubmit(formValues, elementId, caption);
        case 'otherCompany':
            return OtherCompany.getValueSubmit(formValues, elementId, caption);
        case 'examination':
            return Examination.getValueSubmit(formValues, elementId, caption);
        case 'previousexamination':
            return PreviousExamination.getValueSubmit(formValues, elementId, caption);
        case 'groupOfTextFields':
            return GroupOfTextFields.getValueSubmit(formValues, elementId, caption);
        case 'licenseplatefield':
            return LicensePlateField.getValueSubmit(formValues, elementId, caption);
        case 'policedistricts':
            return PoliceDistrict.getValueSubmit(formValues, elementId, caption);
        default:
            throw new Error(`getValueSubmit - Unknown element type: ${elementType}`);
    }
};

// This returns the raw value from state
// It might be a string or an object
export const getValue = (formConfig: FormConfig, formValues: FormValues, elementId: string): any => {
    const element = getElementFromElementId(formConfig, elementId);
    const elementType = element.type;

    switch (elementType) {
        case 'uploadDocumentation':
            return UploadDocumentation.getValue(formValues, elementId);
        case 'radiobuttons':
            return Radiobuttons.getValue(formValues, elementId);
        case 'checkboxes':
            return Checkboxes.getValue(formValues, elementId);
        case 'textfield':
            return Textfield.getValue(formValues, elementId);
        case 'numberfield':
            return NumberField.getValue(formValues, elementId);
        case 'currencyfield':
            return Currencyfield.getValue(formValues, elementId);
        case 'datepicker':
            return Datepicker.getValue(formValues, elementId);
        case 'textarea':
            return Textarea.getValue(formValues, elementId);
        case 'amountOrUnknown':
            return AmountOrUnknown.getValue(formValues, elementId);
        case 'yearfield':
            return Yearfield.getValue(formValues, elementId);
        case 'cprfield':
            return Cprfield.getValue(formValues, elementId);
        case 'cvrfield':
            return Cvrfield.getValue(formValues, elementId);
        case 'dropdown':
            return Dropdown.getValue(formValues, elementId);
        case 'contactEmail':
            return ContactEmail.getValue(formValues, elementId);
        case 'contactPhone':
            return ContactPhone.getValue(formValues, elementId);
        case 'contactUpdateProfile':
            return ContactUpdateProfile.getValue(formValues, elementId);
        case 'houseAddress':
            return HouseAddress.getValue(formValues, elementId);
        case 'addressfield':
            return Addressfield.getValue(formValues, elementId);
        case 'phoneField':
            return PhoneField.getValue(formValues, elementId);
        case 'customerVehicle':
            return CustomerVehicle.getValue(formValues, elementId);
        case 'consent':
            return Consent.getValue(formValues, elementId);
        case 'vehicleZones':
            return VehicleZones.getValue(formValues, elementId);
        case 'timeIntervals':
            return TimeIntervals.getValue(formValues, elementId);
        case 'carBrands':
            return CarBrands.getValue(formValues, elementId);
        case 'countries':
            return Countries.getValue(formValues, elementId);
        case 'supManWidget':
            return SupManWidget.getValue(formValues, elementId);
        case 'selectWorkshop':
            return SelectWorkshop.getValue(formValues, elementId);
        case 'youAreCovered':
            return YouAreCovered.getValue(formValues, elementId);
        case 'scalepointwidget':
            return Scalepoint.getValue(formValues, elementId);
        case 'animal':
            return PetSelector.getValue(formValues, elementId);
        case 'teeth':
            return Teeth.getValue(formConfig, formValues, elementId);
        case 'animalsicknessexistingclaimswidget':
            return PetClaimSelector.getValue(formValues, elementId);
        case 'emailField':
            return EmailField.getValue(formValues, elementId);
        case 'otherCompany':
            return OtherCompany.getValue(formValues, elementId);
        case 'automaticConsent':
            return AutomaticConsent.getValue(formValues, elementId);
        case 'examination':
            return Examination.getValue(formValues, elementId);
        case 'previousexamination':
            return PreviousExamination.getValue(formValues, elementId);
        case 'groupOfTextFields':
            return GroupOfTextFields.getValue(formValues, elementId);
        case 'licenseplatefield':
            return LicensePlateField.getValue(formValues, elementId);
        case 'policedistricts':
            return PoliceDistrict.getValue(formValues, elementId);
        default:
            throw new Error(`getValue - Unknown element type: ${elementType}`);
    }
};

// This returns the human readable value
// It can be used for eg. the resume page or snapshot in TopPro
export const getValueHuman = (formValues: FormValues, formConfig: FormConfig, elementId: string): any => {
    const element = getElementFromElementId(formConfig, elementId);
    const elementType = element.type;

    switch (elementType) {
        case 'uploadDocumentation':
            return UploadDocumentation.getValueHuman(formValues, elementId);
        case 'radiobuttons':
            return Radiobuttons.getValueHuman(formValues, elementId);
        case 'checkboxes':
            return Checkboxes.getValueHuman(formValues, elementId);
        case 'textfield':
            return Textfield.getValueHuman(formValues, elementId);
        case 'numberfield':
            return NumberField.getValueHuman(formValues, elementId);
        case 'currencyfield':
            return Currencyfield.getValueHuman(formValues, elementId);
        case 'datepicker':
            return Datepicker.getValueHuman(formValues, elementId);
        case 'textarea':
            return Textarea.getValueHuman(formValues, elementId);
        case 'amountOrUnknown':
            return AmountOrUnknown.getValueHuman(formValues, elementId);
        case 'yearfield':
            return Yearfield.getValueHuman(formValues, elementId);
        case 'cprfield':
            return Cprfield.getValueHuman(formValues, elementId);
        case 'cvrfield':
            return Cvrfield.getValueHuman(formValues, elementId);
        case 'dropdown':
            return Dropdown.getValueHuman(formValues, elementId);
        case 'contactEmail':
            return ContactEmail.getValueHuman(formValues, elementId);
        case 'contactPhone':
            return ContactPhone.getValueHuman(formValues, elementId);
        case 'contactUpdateProfile':
            return ContactUpdateProfile.getValueHuman(formValues, elementId);
        case 'houseAddress':
            return HouseAddress.getValueHuman(formValues, elementId);
        case 'customerVehicle':
            return CustomerVehicle.getValueHuman(formValues, elementId);
        case 'consent':
            return Consent.getValueHuman(formValues, elementId);
        case 'vehicleZones':
            return VehicleZones.getValueHuman(formValues, elementId);
        case 'timeIntervals':
            return TimeIntervals.getValueHuman(formValues, elementId);
        case 'carBrands':
            return CarBrands.getValueHuman(formValues, elementId);
        case 'countries':
            return Countries.getValueHuman(formValues, elementId);
        case 'supManWidget':
            return SupManWidget.getValueHuman(formValues, elementId);
        case 'selectWorkshop':
            return SelectWorkshop.getValueHuman(formValues, elementId);
        case 'scalepointwidget':
            return Scalepoint.getValueHuman(formValues, elementId);
        case 'animal':
            return PetSelector.getValueHuman(formValues, elementId);
        case 'teeth':
            return Teeth.getValueHuman(formConfig, formValues, elementId);
        case 'animalsicknessexistingclaimswidget':
            return PetClaimSelector.getValueHuman(formValues, elementId);
        case 'emailField':
            return EmailField.getValueHuman(formValues, elementId);
        case 'otherCompany':
            return OtherCompany.getValueHuman(formValues, elementId);
        case 'automaticConsent':
            return AutomaticConsent.getValueHuman(formValues, elementId);
        case 'examination':
            return Examination.getValueHuman(formValues, elementId);
        case 'previousexamination':
            return PreviousExamination.getValueHuman(formValues, elementId);
        case 'groupOfTextFields':
            return GroupOfTextFields.getValueHuman(formValues, elementId);
        case 'licenseplatefield':
            return LicensePlateField.getValueHuman(formValues, elementId);
        case 'policedistricts':
            return PoliceDistrict.getValueHuman(formValues, elementId);
        default:
            throw new Error(`getValueHuman - Unknown element type: ${elementType}`);
    }
};

// This is used in conditional fields to avoid checking on undefined
// It gives a sane default, like the empty string or {}
export const getValueOrDefault = (formConfig: FormConfig, formValues: FormValues, elementId: string): any => {
    const element = getElementFromElementId(formConfig, elementId);
    const elementType = element.type;

    switch (elementType) {
        case 'uploadDocumentation':
            return UploadDocumentation.getValueOrDefault(formValues, elementId);
        case 'radiobuttons':
            return Radiobuttons.getValueOrDefault(formValues, elementId);
        case 'checkboxes':
            return Checkboxes.getValueOrDefault(formValues, elementId);
        case 'textfield':
            return Textfield.getValueOrDefault(formValues, elementId);
        case 'numberfield':
            return NumberField.getValueOrDefault(formValues, elementId);
        case 'currencyfield':
            return Currencyfield.getValueOrDefault(formValues, elementId);
        case 'datepicker':
            return Datepicker.getValueOrDefault(formValues, elementId);
        case 'textarea':
            return Textarea.getValueOrDefault(formValues, elementId);
        case 'amountOrUnknown':
            return AmountOrUnknown.getValueOrDefault(formValues, elementId);
        case 'yearfield':
            return Yearfield.getValueOrDefault(formValues, elementId);
        case 'cprfield':
            return Cprfield.getValueOrDefault(formValues, elementId);
        case 'cvrfield':
            return Cvrfield.getValueOrDefault(formValues, elementId);
        case 'dropdown':
            return Dropdown.getValueOrDefault(formValues, elementId);
        case 'contactEmail':
            return ContactEmail.getValueOrDefault(formValues, elementId);
        case 'contactPhone':
            return ContactPhone.getValueOrDefault(formValues, elementId);
        case 'contactUpdateProfile':
            return ContactUpdateProfile.getValueOrDefault(formValues, elementId);
        case 'houseAddress':
            return HouseAddress.getValueOrDefault(formValues, elementId);
        case 'customerVehicle':
            return CustomerVehicle.getValueOrDefault(formValues, elementId);
        case 'consent':
            return Consent.getValueOrDefault(formValues, elementId);
        case 'vehicleZones':
            return VehicleZones.getValueOrDefault(formValues, elementId);
        case 'timeIntervals':
            return TimeIntervals.getValueOrDefault(formValues, elementId);
        case 'carBrands':
            return CarBrands.getValueOrDefault(formValues, elementId);
        case 'countries':
            return Countries.getValueOrDefault(formValues, elementId);
        case 'supManWidget':
            return SupManWidget.getValueOrDefault(formValues, elementId);
        case 'selectWorkshop':
            return SelectWorkshop.getValueOrDefault(formValues, elementId);
        case 'scalepointwidget':
            return Scalepoint.getValueOrDefault(formValues, elementId);
        case 'animal':
            return PetSelector.getValueOrDefault(formValues, formConfig, elementId);
        case 'teeth':
            return Teeth.getValueOrDefault(formConfig, formValues, elementId);
        case 'animalsicknessexistingclaimswidget':
            return PetClaimSelector.getValueOrDefault(formValues, elementId);
        case 'emailField':
            return EmailField.getValueOrDefault(formValues, elementId);
        case 'otherCompany':
            return OtherCompany.getValueOrDefault(formValues, elementId);
        case 'automaticConsent':
            return AutomaticConsent.getValueOrDefault(formValues, elementId);
        case 'examination':
            return Examination.getValueOrDefault(formValues, elementId);
        case 'previousexamination':
            return PreviousExamination.getValueOrDefault(formValues, elementId);
        case 'groupOfTextFields':
            return GroupOfTextFields.getValueOrDefault(formValues, elementId);
        case 'licenseplatefield':
            return LicensePlateField.getValueOrDefault(formValues, elementId);
        case 'policedistricts':
            return PoliceDistrict.getValueOrDefault(formValues, elementId);
        default:
            throw new Error(`getValueOrEmptyString - Unknown element type: ${elementType}`);
    }
};

// @YIJ
//  - This does not really belong here
//    BUT we need to group all these switches in ONE page
//    to avoid having to change many different places when making a new component
export const ShowElement = (element: Field) => {
    const { type, elementId } = element;

    const formConfig = useAppState((state) => state.formConfig);
    const formValues = useAppState((state) => state.formValues);

    if (!formConfig) {
        return <></>;
    }

    if (!isElementVisible(formConfig, formValues, elementId) || isHiddenElement(formConfig, elementId)) {
        return <></>;
    }

    switch (type) {
        case 'info':
            return <Info {...element} />;
        case 'attention':
            return <Attention {...element} />;
        case 'notImplemented':
            return <NotImplemented {...element} />;
        case 'landingPage':
            return <LandingPage {...element} />;
        case 'contentBlock':
            return <ContentBlock {...element} />;
        case 'summaryPage':
            return <SummaryPage {...element} />;
        case 'uploadDocumentation':
            return <UploadDocumentation {...element} />;
        case 'checkboxes':
            return <Checkboxes {...element} />;
        case 'datepicker':
            return <Datepicker {...element} />;
        case 'radiobuttons':
            return <Radiobuttons {...element} />;
        case 'textarea':
            return <Textarea {...element} />;
        case 'textfield':
            return <Textfield {...element} />;
        case 'currencyfield':
            return <Currencyfield {...element} />;
        case 'numberfield':
            return <NumberField {...element} />;
        case 'amountOrUnknown':
            return <AmountOrUnknown {...element} />;
        case 'yearfield':
            return <Yearfield {...element} />;
        case 'cprfield':
            return <Cprfield {...element} />;
        case 'cvrfield':
            return <Cvrfield {...element} />;
        case 'dropdown':
            return <Dropdown {...element} />;
        case 'contactEmail':
            return <ContactEmail {...element} />;
        case 'contactPhone':
            return <ContactPhone {...element} />;
        case 'contactUpdateProfile':
            return <ContactUpdateProfile {...element} />;
        case 'houseAddress':
            return <HouseAddress {...element} />;
        case 'addressfield':
            return <Addressfield {...element} />;
        case 'phoneField':
            return <PhoneField {...element} />;
        case 'customerVehicle':
            return <CustomerVehicle {...element} />;
        case 'consent':
            return <Consent {...element} />;
        case 'youAreCovered':
            return <YouAreCovered {...element} />;
        case 'vehicleZones':
            return <VehicleZones {...element} />;
        case 'timeIntervals':
            return <TimeIntervals {...element} />;
        case 'carBrands':
            return <CarBrands {...element} />;
        case 'countries':
            return <Countries {...element} />;
        case 'supManWidget':
            return <SupManWidget {...element} />;
        case 'selectWorkshop':
            return <SelectWorkshop {...element} />;
        case 'scalepointwidget':
            return <Scalepoint {...element} />;
        case 'animal':
            return <PetSelector {...element} />;
        case 'teeth':
            return <Teeth {...element} />;
        case 'animalsicknessexistingclaimswidget':
            return <PetClaimSelector {...element} />;
        case 'emailField':
            return <EmailField {...element} />;
        case 'otherCompany':
            return <OtherCompany {...element} />;
        case 'automaticConsent':
            return <AutomaticConsent {...element} />;
        case 'examination':
            return <Examination {...element} />;
        case 'previousexamination':
            return <PreviousExamination {...element} />;
        case 'groupOfTextFields':
            return <GroupOfTextFields {...element} />;
        case 'licenseplatefield':
            return <LicensePlateField {...element} />;
        case 'policedistricts':
            return <PoliceDistrict {...element} />;
        case 'carbucksPage':
            return <CarbucksPage {...element} />;
        default:
            return (
                <pre>
                    <b>Unsupported elementType</b>\n\n{JSON.stringify(element, null, 4)}
                </pre>
            );
    }
};

export const isFieldValid = (
    formConfig: FormConfig,
    formValues: FormValues,
    elementId: string
): boolean | undefined => {
    const element = getElementFromElementId(formConfig, elementId);
    const elementType = element.type;

    switch (elementType) {
        case 'uploadDocumentation':
            return UploadDocumentation.isValid(formConfig, formValues, elementId);
        case 'textarea':
            return Textarea.isValid(formConfig, formValues, elementId);
        case 'textfield':
            return Textfield.isValid(formConfig, formValues, elementId);
        case 'numberfield':
            return NumberField.isValid(formConfig, formValues, elementId);
        case 'currencyfield':
            return Currencyfield.isValid(formConfig, formValues, elementId);
        case 'radiobuttons':
            return Radiobuttons.isValid(formConfig, formValues, elementId);
        case 'checkboxes':
            return Checkboxes.isValid(formConfig, formValues, elementId);
        case 'datepicker':
            return Datepicker.isValid(formConfig, formValues, elementId);
        case 'amountOrUnknown':
            return AmountOrUnknown.isValid(formConfig, formValues, elementId);
        case 'yearfield':
            return Yearfield.isValid(formConfig, formValues, elementId);
        case 'cprfield':
            return Cprfield.isValid(formConfig, formValues, elementId);
        case 'cvrfield':
            return Cvrfield.isValid(formConfig, formValues, elementId);
        case 'dropdown':
            return Dropdown.isValid(formConfig, formValues, elementId);
        case 'landingPage':
            return LandingPage.isValid(formConfig, formValues, elementId);
        case 'contentBlock':
            return ContentBlock.isValid(formConfig, formValues, elementId);
        case 'summaryPage':
            return SummaryPage.isValid(formConfig, formValues, elementId);
        case 'info':
            return Info.isValid(formConfig, formValues, elementId);
        case 'attention':
            return Attention.isValid(formConfig, formValues, elementId);
        case 'contactEmail':
            return ContactEmail.isValid(formConfig, formValues, elementId);
        case 'contactPhone':
            return ContactPhone.isValid(formConfig, formValues, elementId);
        case 'contactUpdateProfile':
            return ContactUpdateProfile.isValid(formConfig, formValues, elementId);
        case 'houseAddress':
            return HouseAddress.isValid(formValues, elementId);
        case 'addressfield':
            return Addressfield.isValid(formConfig, formValues, elementId);
        case 'phoneField':
            return PhoneField.isValid(formConfig, formValues, elementId);
        case 'customerVehicle':
            return CustomerVehicle.isValid(formConfig, formValues, elementId);
        case 'consent':
            return Consent.isValid(formConfig, formValues, elementId);
        case 'youAreCovered':
            return YouAreCovered.isValid();
        case 'vehicleZones':
            return VehicleZones.isValid(formConfig, formValues, elementId);
        case 'timeIntervals':
            return TimeIntervals.isValid(formConfig, formValues, elementId);
        case 'carBrands':
            return CarBrands.isValid(formConfig, formValues, elementId);
        case 'countries':
            return Countries.isValid(formConfig, formValues, elementId);
        case 'supManWidget':
            return SupManWidget.isValid(formConfig, formValues, elementId);
        case 'selectWorkshop':
            return SelectWorkshop.isValid(formConfig, formValues, elementId);
        case 'scalepointwidget':
            return Scalepoint.isValid(formConfig, formValues, elementId);
        case 'animal':
            return PetSelector.isValid(formValues, elementId);
        case 'teeth':
            return Teeth.isValid(formConfig, formValues, elementId);
        case 'animalsicknessexistingclaimswidget':
            return PetClaimSelector.isValid(formValues, elementId);
        case 'emailField':
            return EmailField.isValid(formConfig, formValues, elementId);
        case 'otherCompany':
            return OtherCompany.isValid(formConfig, formValues, elementId);
        case 'notImplemented':
            return NotImplemented.isValid(formConfig, formValues, elementId);
        case 'automaticConsent':
            return AutomaticConsent.isValid(formConfig, formValues, elementId);
        case 'examination':
            return Examination.isValid(formConfig, formValues, elementId);
        case 'previousexamination':
            return PreviousExamination.isValid(formConfig, formValues, elementId);
        case 'groupOfTextFields':
            return GroupOfTextFields.isValid(formConfig, formValues, elementId);
        case 'licenseplatefield':
            return LicensePlateField.isValid(formConfig, formValues, elementId);
        case 'policedistricts':
            return PoliceDistrict.isValid(formConfig, formValues, elementId);
        case 'carbucksPage':
            return CarbucksPage.isValid(formConfig, formValues, elementId);
        default:
            throw new Error(`getIsFieldValid - Unknown element type: ${elementType}`);
    }
};
